export default __webpack_public_path__ + "static/media/a9.60e4cd6b.png";